import React from "react";
import { string, number, array, func, bool } from "prop-types";
import { LoadMoreCollectionStories } from "@quintype/components";

import Stories2AdWithLoadMore from "../Stories2AdWithLoadMore";

const NO_OF_STORIES_TO_LOAD = 20;

const SixteenStories1WidgetWithPollAndLoadMore = ({ collectionSlug, stories }) => {
  const list = stories.map((story) => story);
  const storiesSet = list.map(({ story }) => story).slice(0, 20);

  if (!(list && list.length)) {
    return null;
  }

  return (
    <div>
      {stories.length > 0 && (
        <LoadMoreCollectionStories
          collectionSlug={collectionSlug}
          template={MoreCollectionStories}
          data={{ stories: storiesSet }}
          numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
        />
      )}
    </div>
  );
};

const MoreCollectionStories = ({ stories, onLoadMore, loading, noMoreStories }) => (
  <Stories2AdWithLoadMore
    list={stories}
    loading={loading}
    onLoadMore={onLoadMore}
    isMoreStories={NO_OF_STORIES_TO_LOAD <= stories.length && !noMoreStories}
  />
);

SixteenStories1WidgetWithPollAndLoadMore.propTypes = {
  stories: array,
  collectionSlug: string,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
};

SixteenStories1WidgetWithPollAndLoadMore.storyLimit = 20;

export default SixteenStories1WidgetWithPollAndLoadMore;
